// Keep sync with `ryde-backend/libs/shared/src/enums/production/production-type.enum.ts`
export enum ProductionTypeEnum {
  Shuttle = "Shuttle",
  FlexCourse = "FlexCourse",
  OnDemand = "OnDemand",
  Geo = "Geo",
  Hub = "Hub",
}
